import { prop } from '@ipfabric/utils/fp/prop';
import { useGraphContextSelectors } from 'components/Graph/GraphContext';
import { memo } from 'react';
import { DragLayer } from 'react-dnd';
import { DragLayerRef, dragLayerCollector } from 'utils/dnd/dragLayerCollector';
import { TopologyLayoutSettingsProtocolsProtocol } from './TopologyLayoutSettingsProtocolsProtocol';
import type { DragProtocolItem } from './useProtocolDragAndDrop';

interface DragLayerProps {
  itemType: string | symbol | null;
  item: DragProtocolItem | null;
}

const dragLayerRef = new DragLayerRef();

const BareTopologyLayoutSettingsProtocolsProtocolDragLayer = DragLayer(
  dragLayerCollector(dragLayerRef),
)((props: DragLayerProps) => {
  const ctxProps = useGraphContextSelectors({
    draggedProtocol: prop('layoutSettings', 'draggedProtocol'),
  });

  const protocolIsDragged =
    !!props.item?.protocolName &&
    ctxProps.draggedProtocol === props.item.protocolName;
  if (!protocolIsDragged) {
    return null;
  }

  return (
    <div className='graph-draggable-item__preview'>
      <div
        ref={(ref) => {
          dragLayerRef.setElement(ref);
        }}
        className='graph-draggable-item__box-shadow flex flex-row'
      >
        {props.itemType === 'edge' && (
          // Drag preview protocol
          <TopologyLayoutSettingsProtocolsProtocol
            {...props}
            borderBottom={false}
            disableColor={false}
            disableControls
            disableDeleteButton
            disableDrag={false}
            disableHover={false}
            edgeSettingsId={null}
            groupGrouped={false}
            groupId={null}
            groupIndex={0}
            groupVisible={false}
            grouped={false}
            inGroup
            protocolIndex={0}
            visible
            style={props.item!.style}
            title={props.item!.title}
          />
        )}
      </div>
    </div>
  );
});

export const TopologyLayoutSettingsProtocolsProtocolDragLayer = memo(
  BareTopologyLayoutSettingsProtocolsProtocolDragLayer,
);
